<template>
  <div class="cp-backoffice-contact-edit-view-view">
    <div class="cp-backoffice-contact-edit-view-view-breadcrumbs-container">
      <Breadcrumbs />
    </div>

    <div class="cp-backoffice-contact-edit-view-view-container">
      <ValidationObserver ref="observer">
        <!-- <ValidationProvider
          slim
          rules="required"
          :name="$t('backoffice.breadcrumbs.contact.image')"
          v-slot="{ errors }"
        >
          <b-field
            horizontal
            :type="errors[0] ? 'is-danger' : ''"
            :message="errors[0]"
            :label="$t('backoffice.breadcrumbs.contact.image')"
            v-model="contact_image"
          >
            <div class="cp-backoffice-product-detail-view-upload-groups">
              <Upload
                v-for="(url, index) in contact_image"
                :key="url"
                :url="url"
                :deletable="true"
                @delete-image="deleteImage($event, index)"
                @change-image="changeImage($event, index)"
              />
              <Upload @add-image="addImage" />
            </div>
          </b-field>
        </ValidationProvider> -->
        <ValidationProvider
          slim
          rules="required"
          :name="$t('backoffice.contact.edit.input.address')"
          v-slot="{ errors }"
        >
          <b-field
            horizontal
            label="Address"
            :type="errors[0] ? 'is-danger' : ''"
            :message="errors[0]"
          >
            <Quill v-model="address" />
            <!-- <b-input v-model="address"></b-input> -->
          </b-field>
        </ValidationProvider>

        <!-- <ValidationProvider
          slim
          rules="required"
          :name="$t('backoffice.contact.edit.input.address.en')"
          v-slot="{ errors }"
        >
          <b-field
            horizontal
            :label="$t('backoffice.contact.edit.input.address.en')"
            :type="errors[0] ? 'is-danger' : ''"
            :message="errors[0]"
          >
            <b-input v-model="address_en"></b-input>
          </b-field>
        </ValidationProvider> -->

        <ValidationProvider
          slim
          rules="required|email"
          :name="$t('backoffice.contact.edit.input.email')"
          v-slot="{ errors }"
        >
          <b-field
            horizontal
            :label="$t('backoffice.contact.edit.input.email')"
            :type="errors[0] ? 'is-danger' : ''"
            :message="errors[0]"
          >
            <b-input v-model="email"></b-input>
          </b-field>
        </ValidationProvider>

        <ValidationProvider
          slim
          rules="required|url"
          :name="$t('backoffice.contact.edit.input.facebook')"
          v-slot="{ errors }"
        >
          <b-field
            horizontal
            :label="$t('backoffice.contact.edit.input.facebook')"
            :type="errors[0] ? 'is-danger' : ''"
            :message="errors[0]"
          >
            <b-input v-model="facebook"></b-input>
          </b-field>
        </ValidationProvider>

        <ValidationProvider
          slim
          rules="required"
          :name="$t('backoffice.contact.edit.input.line.id')"
          v-slot="{ errors }"
        >
          <b-field
            horizontal
            :label="$t('backoffice.contact.edit.input.line.id')"
            :type="errors[0] ? 'is-danger' : ''"
            :message="errors[0]"
          >
            <b-input v-model="line_id"></b-input>
          </b-field>
        </ValidationProvider>

        <ValidationProvider
          slim
          rules="required"
          :name="$t('backoffice.contact.edit.input.phone.number')"
          v-slot="{ errors }"
        >
          <b-field
            horizontal
            :label="$t('backoffice.contact.edit.input.phone.number')"
            :type="errors[0] ? 'is-danger' : ''"
            :message="errors[0]"
          >
            <b-input v-model="phone_number"></b-input>
          </b-field>
        </ValidationProvider>

        <ValidationProvider
          slim
          rules="url"
          :name="$t('backoffice.contact.edit.input.twitter')"
          v-slot="{ errors }"
        >
          <b-field
            horizontal
            :label="$t('backoffice.contact.edit.input.twitter')"
            :type="errors[0] ? 'is-danger' : ''"
            :message="errors[0]"
          >
            <b-input v-model="twitter"></b-input>
          </b-field>
        </ValidationProvider>

        <ValidationProvider
          slim
          rules="url"
          :name="$t('backoffice.contact.edit.input.youtube')"
          v-slot="{ errors }"
        >
          <b-field
            horizontal
            :label="$t('backoffice.contact.edit.input.youtube')"
            :type="errors[0] ? 'is-danger' : ''"
            :message="errors[0]"
          >
            <b-input v-model="youtube"></b-input>
          </b-field>
        </ValidationProvider>
      </ValidationObserver>

      <br />

      <b-button
        class="cp-backoffice-contact-edit-view-view-save-button"
        type="is-primary"
        rounded
        :disabled="disabled"
        :loading="saveLoading"
        @click="save"
        >{{ $t('backoffice.common.save.label') }}</b-button
      >
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/backoffice/Breadcrumbs.vue';
// import Upload from '@/components/backoffice/Upload.vue';
import Quill from '@/components/Quill/Quill.vue';
import { getContact, saveContact } from '@/apis/contact';

export default {
  name: 'AboutEditView',
  components: {
    Breadcrumbs,
    Quill,
    // Upload
  },
  data() {
    return {
      disabled: false,
      saveLoading: false,
      address: '',
      address_en: '',
      email: '',
      facebook: '',
      line_id: '',
      phone_number: '',
      twitter: '',
      youtube: '',
      contact_image: [],
    };
  },
  async mounted() {
    const loading = this.$buefy.loading.open();

    try {
      const contact = await getContact();

      this.address = contact.address;
      this.address_en = contact.address_en;
      this.email = contact.email;
      this.facebook = contact.facebook;
      this.line_id = contact.line_id;
      this.phone_number = contact.phone_number;
      this.twitter = contact.twitter;
      this.youtube = contact.youtube;
    } catch (error) {
      this.$buefy.snackbar.open({
        message: this.$t('backoffice.common.fetch.fail'),
        type: 'is-danger',
        position: 'is-top',
        actionText: this.$t('snackbar.ok.text'),
        duration: 2000,
      });

      this.disabled = true;
      this.$sentry.captureException(error);
    } finally {
      loading.close();
    }
  },
  methods: {
    async save() {
      const success = await this.$refs.observer.validate();

      if (!success) {
        return;
      }

      this.saveLoading = true;

      try {
        const data = {
          address: this.address,
          address_en: this.address_en,
          email: this.email,
          facebook: this.facebook,
          line_id: this.line_id,
          phone_number: this.phone_number,
          twitter: this.twitter,
          youtube: this.youtube,
        };

        await saveContact(data);

        this.$buefy.snackbar.open({
          message: this.$t('backoffice.contact.save.success'),
          type: 'is-success',
          position: 'is-top',
          actionText: this.$t('snackbar.ok.text'),
          duration: 2000,
        });

        this.$router.push({
          name: 'BackofficeContact',
        });
      } catch (error) {
        this.$buefy.snackbar.open({
          message: this.$t('backoffice.contact.save.fail'),
          type: 'is-danger',
          position: 'is-top',
          actionText: this.$t('snackbar.ok.text'),
          duration: 2000,
        });

        this.$sentry.captureException(error);
      } finally {
        this.saveLoading = false;
      }
    },
    deleteImage(url, index) {
      this.contact_image = this.contact_image.filter((_, idx) => idx !== index);
    },
    changeImage(url, index) {
      this.contact_image = this.contact_image.map((old, idx) => (idx === index ? url : old));
    },
    addImage(url) {
      this.contact_image.push(url);
    },
  },
};
</script>

<style lang="scss" scoped>
.cp-backoffice-contact-edit-view-view {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 30px;

  &-container {
    flex-grow: 1;
    border: 1px solid #cacaca;
    padding: 40px;
  }

  &-save-button {
    width: 100px;
  }
}
</style>
